
export const scrollIntoViewIfNecessary = (element: HTMLElement | null) => {
  if (!!element) {
    const rect = element.getBoundingClientRect();
    if (!!window && !!rect && (window.innerHeight < rect.top || rect.top < 0)) {
      element.scrollIntoView();
    }
  }
};
